import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CorrelationIdService } from '../correlation-id.service';

@Injectable({
  providedIn: 'root',
})
export class OtpService {
  baseUrl: string = '/ncfr-api';
  correlationId: string;

  constructor(
    private httpClient: HttpClient,
    private correlationIdService: CorrelationIdService
  ) {
    this.correlationIdService
      .getCorrelationId()
      .subscribe(value => (this.correlationId = value));
  }

  private eventSubject = new BehaviorSubject<any>(undefined);

  getEventSubject(): BehaviorSubject<any> {
    return this.eventSubject;
  }

  //invio otp
  generateCode(): Observable<any> {
    const scope = null;
    const resourceId = null;
    return this.httpClient.post<any>(
      this.baseUrl + '/otp',
      // scope e resourceId devono essere null
      { scope, resourceId },
      {
        headers: {
          'InfoCert-Correlation-ID': this.correlationId,
        },
      }
    );
  }

  //invio codice di conferma al nuovo numero
  generateCodeForNewMobile(): Observable<any> {
    const scope = null;
    const resourceId = null;
    return this.httpClient.post<any>(
      this.baseUrl + '/v1/otp',
      // scope e resourceId devono essere null
      { scope, resourceId },
      {
        headers: {
          'InfoCert-Correlation-ID': this.correlationId,
        },
      }
    );
  }

  //invio otp e codice di conferma al nuovo numero
  generateCodeForOldAndNewMobile({
    newMobile,
  }: {
    newMobile: string;
  }): Observable<any> {
    const scope = null;
    const resourceId = null;
    return this.httpClient.post<any>(
      this.baseUrl + '/otp',
      // scope e resourceId devono essere null
      { scope, resourceId, newMobile },
      {
        headers: {
          'InfoCert-Correlation-ID': this.correlationId,
        },
      }
    );
  }

  resetOtpInputVal(param: any) {
    this.eventSubject.next(param);
  }

  // Metodi specifici per reset categorizzati
  resetAllOtpInputs() {
    this.eventSubject.next('all');
  }

  resetSmsOtpInputs() {
    this.eventSubject.next('sms');
  }

  resetTrissOtpInputs() {
    this.eventSubject.next('triss');
  }

  resetHardwareOtpInputs() {
    this.eventSubject.next('hardware');
  }

  resetOtpInputGroup(group: string) {
    this.eventSubject.next(group);
  }
}
